// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --his: #e25d68;
  --geo: #cd7130;
  --ere: #958b23;
  --fil: #958b23;
  --soc: #958b23;
  --efi: #679723;
  --cie: #2f9d25;
  --bio: #2f9d25;
  --inf: #2f9d25;
  --qui: #249c56;
  --fis: #24998f;
  --mat: #318fd2;
  --ing: #7680e7;
  --esp: #7680e7;
  --por: #a170e6;
  --lit: #d44fe0;
  --art: #e154a6;
  --tra: #7b8b98;
  --lib: #7b8b98;
}
:root .nightMode {
  --his: #f5c8cc;
  --geo: #f1ccb1;
  --ere: #e2d658;
  --fil: #e2d658;
  --soc: #e2d658;
  --efi: #aee362;
  --cie: #89e980;
  --bio: #89e980;
  --inf: #89e980;
  --qui: #7de8aa;
  --fis: #70e6dc;
  --mat: #b3d8f2;
  --ing: #cdd0f6;
  --esp: #cdd0f6;
  --por: #ddccf6;
  --lit: #f1c5f5;
  --art: #f5c6e1;
  --tra: #dde1e5;
  --lib: #dde1e5;
}

:root {
  --foreground-color-1: #384046;
  --foreground-color-1-alpha: rgba(56, 64, 70, 0.25);
  --foreground-color-1-light: #dde1e5;
  --foreground-color-2: #3394db;
  --foreground-color-2-alpha: rgba(51, 148, 219, 0.5);
  --foreground-color-3: #fdfdfd;
  --background-color-1: #fdfdfd;
  --background-color-1-alpha: rgba(253, 253, 253, 0.5);
  --background-color-2: #3394db;
  --background-color-2-alpha: rgba(51, 148, 219, 0.5);
  --background-color-3: #005a8f;
  --background-color-3-alpha: rgba(0, 90, 143, 0.5);
  --background-color-4: #e6e6e6;
  --grassColor: #9acc00;
  --mudColor: saddlebrown;
  --mudColor-alpha: rgba(139, 69, 19, 0.5);
  --flowerPetal: #f00000;
  --flowerCore: #efc10e;
  --sparkColor: #f68b1e;
  --bushColor: #1d7208;
  --balloonBackground: #fdfdfd;
  --wood: #8b4513;
  --woodHighlight: #4e2103;
  --riverWater: #3394db;
  --stone: #cccccc;
  --warn: #dc8f20;
}
:root .nightMode {
  --foreground-color-1: #fdfdfd;
  --foreground-color-1-alpha: rgba(253, 253, 253, 0.25);
  --foreground-color-1-light: #384046;
  --foreground-color-2: #8ac1ea;
  --foreground-color-2-alpha: rgba(138, 193, 234, 0.5);
  --background-color-1: #171717;
  --background-color-1-alpha: rgba(23, 23, 23, 0.5);
  --background-color-2: #384046;
  --background-color-3: #fdfdfd;
  --background-color-3-alpha: rgba(253, 253, 253, 0.5);
  --background-color-4: #333333;
  --grassColor: #05211a;
  --mudColor: #010000;
  --mudColor-alpha: rgba(1, 0, 0, 0.5);
  --flowerPetal: #363357;
  --flowerCore: #ffffe0;
  --sparkColor: #ff0;
  --bushColor: #0b3a00;
  --balloonBackground: #081824;
  --wood: #1d0c00;
  --woodHighlight: #140800;
  --riverWater: #005a8f;
  --stone: #3a3a3a;
}
:root .his {
  --foreground-color-2: #e25d68;
  --background-color-2: #e25d68;
  --background-color-3: #791c24;
  --background-color-3-alpha: rgba(121, 28, 36, 0.5);
  --subject: #e25d68;
  --darksubject: #791c24;
  --lightsubject: #f5c8cc;
  --subjectAlpha: rgba(226, 93, 104, 0.5);
  --darksubjectAlpha: rgba(121, 28, 36, 0.5);
  --lightsubjectAlpha: rgba(245, 200, 204, 0.5);
}
:root .his.nightMode {
  --foreground-color-2: #f5c8cc;
  --background-color-2: #791c24;
}
:root .geo {
  --foreground-color-2: #cd7130;
  --background-color-2: #cd7130;
  --background-color-3: #5f3516;
  --background-color-3-alpha: rgba(95, 53, 22, 0.5);
  --subject: #cd7130;
  --darksubject: #5f3516;
  --lightsubject: #f1ccb1;
  --subjectAlpha: rgba(205, 113, 48, 0.5);
  --darksubjectAlpha: rgba(95, 53, 22, 0.5);
  --lightsubjectAlpha: rgba(241, 204, 177, 0.5);
}
:root .geo.nightMode {
  --foreground-color-2: #f1ccb1;
  --background-color-2: #5f3516;
}
:root .ere {
  --foreground-color-2: #958b23;
  --background-color-2: #958b23;
  --background-color-3: #454010;
  --background-color-3-alpha: rgba(69, 64, 16, 0.5);
  --subject: #958b23;
  --darksubject: #454010;
  --lightsubject: #e2d658;
  --subjectAlpha: rgba(149, 139, 35, 0.5);
  --darksubjectAlpha: rgba(69, 64, 16, 0.5);
  --lightsubjectAlpha: rgba(226, 214, 88, 0.5);
}
:root .ere.nightMode {
  --foreground-color-2: #e2d658;
  --background-color-2: #454010;
}
:root .fil {
  --foreground-color-2: #958b23;
  --background-color-2: #958b23;
  --background-color-3: #454010;
  --background-color-3-alpha: rgba(69, 64, 16, 0.5);
  --subject: #958b23;
  --darksubject: #454010;
  --lightsubject: #e2d658;
  --subjectAlpha: rgba(149, 139, 35, 0.5);
  --darksubjectAlpha: rgba(69, 64, 16, 0.5);
  --lightsubjectAlpha: rgba(226, 214, 88, 0.5);
}
:root .fil.nightMode {
  --foreground-color-2: #e2d658;
  --background-color-2: #454010;
}
:root .soc {
  --foreground-color-2: #958b23;
  --background-color-2: #958b23;
  --background-color-3: #454010;
  --background-color-3-alpha: rgba(69, 64, 16, 0.5);
  --subject: #958b23;
  --darksubject: #454010;
  --lightsubject: #e2d658;
  --subjectAlpha: rgba(149, 139, 35, 0.5);
  --darksubjectAlpha: rgba(69, 64, 16, 0.5);
  --lightsubjectAlpha: rgba(226, 214, 88, 0.5);
}
:root .soc.nightMode {
  --foreground-color-2: #e2d658;
  --background-color-2: #454010;
}
:root .efi {
  --foreground-color-2: #679723;
  --background-color-2: #679723;
  --background-color-3: #2f4610;
  --background-color-3-alpha: rgba(47, 70, 16, 0.5);
  --subject: #679723;
  --darksubject: #2f4610;
  --lightsubject: #aee362;
  --subjectAlpha: rgba(103, 151, 35, 0.5);
  --darksubjectAlpha: rgba(47, 70, 16, 0.5);
  --lightsubjectAlpha: rgba(174, 227, 98, 0.5);
}
:root .efi.nightMode {
  --foreground-color-2: #aee362;
  --background-color-2: #2f4610;
}
:root .cie {
  --foreground-color-2: #2f9d25;
  --background-color-2: #2f9d25;
  --background-color-3: #164911;
  --background-color-3-alpha: rgba(22, 73, 17, 0.5);
  --subject: #2f9d25;
  --darksubject: #164911;
  --lightsubject: #89e980;
  --subjectAlpha: rgba(47, 157, 37, 0.5);
  --darksubjectAlpha: rgba(22, 73, 17, 0.5);
  --lightsubjectAlpha: rgba(137, 233, 128, 0.5);
}
:root .cie.nightMode {
  --foreground-color-2: #89e980;
  --background-color-2: #164911;
}
:root .bio {
  --foreground-color-2: #2f9d25;
  --background-color-2: #2f9d25;
  --background-color-3: #164911;
  --background-color-3-alpha: rgba(22, 73, 17, 0.5);
  --subject: #2f9d25;
  --darksubject: #164911;
  --lightsubject: #89e980;
  --subjectAlpha: rgba(47, 157, 37, 0.5);
  --darksubjectAlpha: rgba(22, 73, 17, 0.5);
  --lightsubjectAlpha: rgba(137, 233, 128, 0.5);
}
:root .bio.nightMode {
  --foreground-color-2: #89e980;
  --background-color-2: #164911;
}
:root .inf {
  --foreground-color-2: #2f9d25;
  --background-color-2: #2f9d25;
  --background-color-3: #164911;
  --background-color-3-alpha: rgba(22, 73, 17, 0.5);
  --subject: #2f9d25;
  --darksubject: #164911;
  --lightsubject: #89e980;
  --subjectAlpha: rgba(47, 157, 37, 0.5);
  --darksubjectAlpha: rgba(22, 73, 17, 0.5);
  --lightsubjectAlpha: rgba(137, 233, 128, 0.5);
}
:root .inf.nightMode {
  --foreground-color-2: #89e980;
  --background-color-2: #164911;
}
:root .qui {
  --foreground-color-2: #249c56;
  --background-color-2: #249c56;
  --background-color-3: #114928;
  --background-color-3-alpha: rgba(17, 73, 40, 0.5);
  --subject: #249c56;
  --darksubject: #114928;
  --lightsubject: #7de8aa;
  --subjectAlpha: rgba(36, 156, 86, 0.5);
  --darksubjectAlpha: rgba(17, 73, 40, 0.5);
  --lightsubjectAlpha: rgba(125, 232, 170, 0.5);
}
:root .qui.nightMode {
  --foreground-color-2: #7de8aa;
  --background-color-2: #114928;
}
:root .fis {
  --foreground-color-2: #24998f;
  --background-color-2: #24998f;
  --background-color-3: #114742;
  --background-color-3-alpha: rgba(17, 71, 66, 0.5);
  --subject: #24998f;
  --darksubject: #114742;
  --lightsubject: #70e6dc;
  --subjectAlpha: rgba(36, 153, 143, 0.5);
  --darksubjectAlpha: rgba(17, 71, 66, 0.5);
  --lightsubjectAlpha: rgba(112, 230, 220, 0.5);
}
:root .fis.nightMode {
  --foreground-color-2: #70e6dc;
  --background-color-2: #114742;
}
:root .mat {
  --foreground-color-2: #318fd2;
  --background-color-2: #318fd2;
  --background-color-3: #174262;
  --background-color-3-alpha: rgba(23, 66, 98, 0.5);
  --subject: #318fd2;
  --darksubject: #174262;
  --lightsubject: #b3d8f2;
  --subjectAlpha: rgba(49, 143, 210, 0.5);
  --darksubjectAlpha: rgba(23, 66, 98, 0.5);
  --lightsubjectAlpha: rgba(179, 216, 242, 0.5);
}
:root .mat.nightMode {
  --foreground-color-2: #b3d8f2;
  --background-color-2: #174262;
}
:root .ing {
  --foreground-color-2: #7680e7;
  --background-color-2: #7680e7;
  --background-color-3: #252fa0;
  --background-color-3-alpha: rgba(37, 47, 160, 0.5);
  --subject: #7680e7;
  --darksubject: #252fa0;
  --lightsubject: #cdd0f6;
  --subjectAlpha: rgba(118, 128, 231, 0.5);
  --darksubjectAlpha: rgba(37, 47, 160, 0.5);
  --lightsubjectAlpha: rgba(205, 208, 246, 0.5);
}
:root .ing.nightMode {
  --foreground-color-2: #cdd0f6;
  --background-color-2: #252fa0;
}
:root .esp {
  --foreground-color-2: #7680e7;
  --background-color-2: #7680e7;
  --background-color-3: #252fa0;
  --background-color-3-alpha: rgba(37, 47, 160, 0.5);
  --subject: #7680e7;
  --darksubject: #252fa0;
  --lightsubject: #cdd0f6;
  --subjectAlpha: rgba(118, 128, 231, 0.5);
  --darksubjectAlpha: rgba(37, 47, 160, 0.5);
  --lightsubjectAlpha: rgba(205, 208, 246, 0.5);
}
:root .esp.nightMode {
  --foreground-color-2: #cdd0f6;
  --background-color-2: #252fa0;
}
:root .por {
  --foreground-color-2: #a170e6;
  --background-color-2: #a170e6;
  --background-color-3: #512293;
  --background-color-3-alpha: rgba(81, 34, 147, 0.5);
  --subject: #a170e6;
  --darksubject: #512293;
  --lightsubject: #ddccf6;
  --subjectAlpha: rgba(161, 112, 230, 0.5);
  --darksubjectAlpha: rgba(81, 34, 147, 0.5);
  --lightsubjectAlpha: rgba(221, 204, 246, 0.5);
}
:root .por.nightMode {
  --foreground-color-2: #ddccf6;
  --background-color-2: #512293;
}
:root .lit {
  --foreground-color-2: #d44fe0;
  --background-color-2: #d44fe0;
  --background-color-3: #6a1a71;
  --background-color-3-alpha: rgba(106, 26, 113, 0.5);
  --subject: #d44fe0;
  --darksubject: #6a1a71;
  --lightsubject: #f1c5f5;
  --subjectAlpha: rgba(212, 79, 224, 0.5);
  --darksubjectAlpha: rgba(106, 26, 113, 0.5);
  --lightsubjectAlpha: rgba(241, 197, 245, 0.5);
}
:root .lit.nightMode {
  --foreground-color-2: #f1c5f5;
  --background-color-2: #6a1a71;
}
:root .art {
  --foreground-color-2: #e154a6;
  --background-color-2: #e154a6;
  --background-color-3: #731b4e;
  --background-color-3-alpha: rgba(115, 27, 78, 0.5);
  --subject: #e154a6;
  --darksubject: #731b4e;
  --lightsubject: #f5c6e1;
  --subjectAlpha: rgba(225, 84, 166, 0.5);
  --darksubjectAlpha: rgba(115, 27, 78, 0.5);
  --lightsubjectAlpha: rgba(245, 198, 225, 0.5);
}
:root .art.nightMode {
  --foreground-color-2: #f5c6e1;
  --background-color-2: #731b4e;
}
:root .lib {
  --foreground-color-2: #318fd2;
  --background-color-2: #318fd2;
  --background-color-3: #174262;
  --background-color-3-alpha: rgba(23, 66, 98, 0.5);
  --subject: #318fd2;
  --darksubject: #174262;
  --lightsubject: #b3d8f2;
  --subjectAlpha: rgba(49, 143, 210, 0.5);
  --darksubjectAlpha: rgba(23, 66, 98, 0.5);
  --lightsubjectAlpha: rgba(179, 216, 242, 0.5);
}
:root .lib.nightMode {
  --foreground-color-2: #b3d8f2;
  --background-color-2: #174262;
}
:root .tra {
  --foreground-color-2: #7b8b98;
  --background-color-2: #7b8b98;
  --background-color-3: #384046;
  --background-color-3-alpha: rgba(56, 64, 70, 0.5);
  --subject: #7b8b98;
  --darksubject: #384046;
  --lightsubject: #dde1e5;
  --subjectAlpha: rgba(123, 139, 152, 0.5);
  --darksubjectAlpha: rgba(56, 64, 70, 0.5);
  --lightsubjectAlpha: rgba(221, 225, 229, 0.5);
}
:root .tra.nightMode {
  --foreground-color-2: #dde1e5;
  --background-color-2: #384046;
}

@media print {
  @page {
    size: A4 portrait;
    margin: 0;
  }
  * {
    box-sizing: border-box;
    transition: none !important;
  }
  body > *:not(#print-root) {
    display: none;
  }
  body,
  #print-root {
    -webkit-print-color-adjust: exact;
            color-adjust: exact;
  }
  #print-root {
    --blue: \$darkblue;
    --darkblue: \$darkgray;
    --lightgray: white;
    --gray: black;
    --darkgray: black;
    --white: white;
    --black: black;
  }
  .page {
    margin: 0;
    min-height: 100vh !important;
    width: 100vw !important;
    font-family: Arial;
    display: flex;
    flex-wrap: wrap;
    padding: 4mm;
    align-items: flex-start;
    justify-content: flex-start;
    align-content: flex-start;
    page-break-after: always !important;
    overflow: hidden;
  }
  .page :first-of-type .tag {
    transform: translateY(0.5mm);
  }
  .page :last-child {
    height: auto;
  }
  .tag-wrapper {
    position: relative;
    width: 50%;
    height: 38.3mm;
    min-height: 38.3mm;
    max-height: 38.3mm;
    page-break-inside: avoid;
  }
  .tag-wrapper .tag {
    position: absolute;
    top: 3mm;
    left: 3mm;
    right: 3mm;
    bottom: 3mm;
    border: 0.4mm solid #ccc;
    display: grid;
    padding: 2mm;
    border-radius: 2mm;
    grid-gap: 1mm;
    gap: 1mm;
    grid-template: "levelGrade site" 1fr "name name" 2fr "credentials credentials" 3fr/1fr 1fr;
    overflow: hidden;
  }
  .tag-wrapper .tag .name {
    grid-area: name;
    font-weight: var(--bold);
    border-bottom: 0.4mm solid #ccc;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 11pt;
  }
  .tag-wrapper .tag .levelGrade {
    grid-area: levelGrade;
    font-size: 8pt;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .tag-wrapper .tag .site {
    grid-area: site;
    text-align: right;
    font-size: 8pt;
  }
  .tag-wrapper .tag .credentials {
    grid-area: credentials;
    display: flex;
    flex-direction: column;
  }
  .tag-wrapper .tag .credentials h4 {
    margin: 0;
    padding: 0;
    font-size: 9.5pt;
  }
  .tag-wrapper .tag .credentials p {
    margin: 0;
    padding: 0;
    font-size: 10pt;
  }
  .tag-wrapper .tag .credentials .password {
    margin-top: 2px;
    flex-shrink: 1;
  }
  .tag-wrapper .tag .logo {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    filter: grayscale(1) opacity(0.15);
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    padding: 2mm;
  }
  .tag-wrapper .tag .logo img {
    height: 50%;
  }
}
@media not print {
  #print-root {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/core/_colors.scss","webpack://./src/views/UserManagement/Projects/PrintLogins/printable.scss"],"names":[],"mappings":"AA4HA;EACE,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;AC3HF;AD6HE;EACE,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;AC3HJ;;AD0OA;EACE,6BAAA;EACA,kDAAA;EACA,mCAAA;EACA,6BAAA;EACA,mDAAA;EACA,6BAAA;EAEA,6BAAA;EACA,oDAAA;EACA,6BAAA;EACA,mDAAA;EACA,6BAAA;EACA,iDAAA;EACA,6BAAA;EAEA,qBAAA;EACA,uBAAA;EACA,wCAAA;EAEA,sBAAA;EACA,qBAAA;EAEA,qBAAA;EAEA,oBAAA;EAEA,4BAAA;EAEA,eAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EAEA,eAAA;AC/OF;ADgPE;EACE,6BAAA;EACA,qDAAA;EACA,mCAAA;EACA,6BAAA;EACA,oDAAA;EAEA,6BAAA;EACA,iDAAA;EACA,6BAAA;EACA,6BAAA;EACA,oDAAA;EACA,6BAAA;EAEA,qBAAA;EACA,mBAAA;EACA,oCAAA;EAEA,sBAAA;EACA,qBAAA;EAEA,kBAAA;EAEA,oBAAA;EAEA,4BAAA;EAEA,eAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;ACrPJ;ADwPI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,kDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uCAAA;EACA,0CAAA;EACA,6CAAA;ACtPN;ADuPM;EACE,6BAAA;EACA,6BAAA;ACrPR;ADwOI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uCAAA;EACA,yCAAA;EACA,6CAAA;ACtON;ADuOM;EACE,6BAAA;EACA,6BAAA;ACrOR;ADwNI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uCAAA;EACA,yCAAA;EACA,4CAAA;ACtNN;ADuNM;EACE,6BAAA;EACA,6BAAA;ACrNR;ADwMI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uCAAA;EACA,yCAAA;EACA,4CAAA;ACtMN;ADuMM;EACE,6BAAA;EACA,6BAAA;ACrMR;ADwLI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uCAAA;EACA,yCAAA;EACA,4CAAA;ACtLN;ADuLM;EACE,6BAAA;EACA,6BAAA;ACrLR;ADwKI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uCAAA;EACA,yCAAA;EACA,4CAAA;ACtKN;ADuKM;EACE,6BAAA;EACA,6BAAA;ACrKR;ADwJI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,sCAAA;EACA,yCAAA;EACA,6CAAA;ACtJN;ADuJM;EACE,6BAAA;EACA,6BAAA;ACrJR;ADwII;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,sCAAA;EACA,yCAAA;EACA,6CAAA;ACtIN;ADuIM;EACE,6BAAA;EACA,6BAAA;ACrIR;ADwHI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,sCAAA;EACA,yCAAA;EACA,6CAAA;ACtHN;ADuHM;EACE,6BAAA;EACA,6BAAA;ACrHR;ADwGI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,sCAAA;EACA,yCAAA;EACA,6CAAA;ACtGN;ADuGM;EACE,6BAAA;EACA,6BAAA;ACrGR;ADwFI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uCAAA;EACA,yCAAA;EACA,6CAAA;ACtFN;ADuFM;EACE,6BAAA;EACA,6BAAA;ACrFR;ADwEI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uCAAA;EACA,yCAAA;EACA,6CAAA;ACtEN;ADuEM;EACE,6BAAA;EACA,6BAAA;ACrER;ADwDI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,kDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,wCAAA;EACA,0CAAA;EACA,6CAAA;ACtDN;ADuDM;EACE,6BAAA;EACA,6BAAA;ACrDR;ADwCI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,kDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,wCAAA;EACA,0CAAA;EACA,6CAAA;ACtCN;ADuCM;EACE,6BAAA;EACA,6BAAA;ACrCR;ADwBI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,kDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,wCAAA;EACA,0CAAA;EACA,6CAAA;ACtBN;ADuBM;EACE,6BAAA;EACA,6BAAA;ACrBR;ADQI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,mDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uCAAA;EACA,2CAAA;EACA,6CAAA;ACNN;ADOM;EACE,6BAAA;EACA,6BAAA;ACLR;ADRI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,kDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uCAAA;EACA,0CAAA;EACA,6CAAA;ACUN;ADTM;EACE,6BAAA;EACA,6BAAA;ACWR;ADxBI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uCAAA;EACA,yCAAA;EACA,6CAAA;AC0BN;ADzBM;EACE,6BAAA;EACA,6BAAA;AC2BR;ADxCI;EACE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,wCAAA;EACA,yCAAA;EACA,6CAAA;AC0CN;ADzCM;EACE,6BAAA;EACA,6BAAA;AC2CR;;AA7YA;EACE;IACE,iBAAA;IACA,SAAA;EAgZF;EA9YA;IACE,sBAAA;IACA,2BAAA;EAgZF;EA9YA;IACE,aAAA;EAgZF;EA9YA;;IAEE,iCAAA;YAAA,mBAAA;EAgZF;EA9YA;IACE,iBAAA;IACA,qBAAA;IACA,kBAAA;IACA,aAAA;IACA,iBAAA;IACA,cAAA;IACA,cAAA;EAgZF;EA7YA;IACE,SAAA;IACA,4BAAA;IACA,uBAAA;IACA,kBAAA;IACA,aAAA;IACA,eAAA;IACA,YAAA;IACA,uBAAA;IACA,2BAAA;IACA,yBAAA;IACA,mCAAA;IACA,gBAAA;EA+YF;EA7YE;IACE,4BAAA;EA+YJ;EA7YE;IACE,YAAA;EA+YJ;EA3YA;IACE,kBAAA;IACA,UAAA;IACA,cAAA;IACA,kBAAA;IACA,kBAAA;IACA,wBAAA;EA6YF;EA3YE;IACE,kBAAA;IACA,QAAA;IACA,SAAA;IACA,UAAA;IACA,WAAA;IACA,wBAAA;IACA,aAAA;IACA,YAAA;IACA,kBAAA;IACA,aAAA;IAAA,QAAA;IACA,0FACE;IAIF,gBAAA;EAyYJ;EAvYI;IACE,eAAA;IACA,wBAAA;IACA,+BAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;IACA,eAAA;EAyYN;EAtYI;IACE,qBAAA;IACA,cAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EAwYN;EArYI;IACE,eAAA;IACA,iBAAA;IACA,cAAA;EAuYN;EApYI;IACE,sBAAA;IACA,aAAA;IACA,sBAAA;EAsYN;EApYM;IACE,SAAA;IACA,UAAA;IACA,gBAAA;EAsYR;EAnYM;IACE,SAAA;IACA,UAAA;IACA,eAAA;EAqYR;EAlYM;IACE,eAAA;IACA,cAAA;EAoYR;EA/XI;IACE,kBAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,kCAAA;IACA,aAAA;IACA,qBAAA;IACA,yBAAA;IACA,YAAA;EAiYN;EA/XM;IACE,WAAA;EAiYR;AACF;AA3XA;EACE;IACE,aAAA;EA6XF;AACF","sourcesContent":["$click-blue: #3394db;\n$click-darkblue: #005a8f;\n$click-lightblue: #8ac1ea;\n$click-orange: #dc8f20;\n$click-white: #fdfdfd;\n$click-black: #303030;\n$click-darkgray: #333333;\n$click-gray: #777777;\n$click-gray-10: #e6e6e6;\n$click-gray-30: #b3b3b3;\n$click-gray-40: #999999;\n\n$lightblue: #8ac1ea;\n$blue: #3394db;\n$darkblue: #005a8f;\n$lightgray: #e6e6e6;\n$gray: #777777;\n$darkgray: #333333;\n$white: #fdfdfd;\n$black: #171717;\n\n$lightblueAlpha: rgba($lightblue, 0.5);\n$blueAlpha: rgba($blue, 0.5);\n$darkblueAlpha: rgba($darkblue, 0.5);\n$lightgrayAlpha: rgba($lightgray, 0.5);\n$grayAlpha: rgba($gray, 0.5);\n$darkgrayAlpha: rgba($darkgray, 0.5);\n$whiteAlpha: rgba($white, 0.5);\n$blackAlpha: rgba($black, 0.5);\n\n$palx-darkblue: #174262;\n$palx-blue: #318fd2;\n$palx-lightblue: #b3d8f2;\n\n$palx-darkindigo: #252fa0;\n$palx-indigo: #7680e7;\n$palx-lightindigo: #cdd0f6;\n\n$palx-darkviolet: #512293;\n$palx-violet: #a170e6;\n$palx-lightviolet: #ddccf6;\n\n$palx-darkfuschia: #6a1a71;\n$palx-fuschia: #d44fe0;\n$palx-lightfuschia: #f1c5f5;\n\n$palx-darkpink: #731b4e;\n$palx-pink: #e154a6;\n$palx-lightpink: #f5c6e1;\n\n$palx-darkred: #791c24;\n$palx-darkishred: #ae3d46;\n$palx-red: #e25d68;\n$palx-lightred: #f5c8cc;\n\n$palx-darkorange: #5f3516;\n$palx-orange: #cd7130;\n$palx-lightorange: #f1ccb1;\n\n$palx-darkyellow: #454010;\n$palx-yellow: #958b23;\n$palx-lightyellow: #e2d658;\n\n$palx-darklime: #2f4610;\n$palx-lime: #679723;\n$palx-lightlime: #aee362;\n\n$palx-darkgreen: #164911;\n$palx-darkishgreen: #23731b;\n$palx-green: #2f9d25;\n$palx-lightgreen: #89e980;\n\n$palx-darkteal: #114928;\n$palx-teal: #249c56;\n$palx-lightteal: #7de8aa;\n\n$palx-darkcyan: #114742;\n$palx-cyan: #24998f;\n$palx-lightcyan: #70e6dc;\n\n$palx-darkgray: #384046;\n$palx-gray: #7b8b98;\n$palx-lightgray: #dde1e5;\n\n$lightdanger: $palx-lightred;\n$danger: $palx-darkishred;\n$lightsuccess: $palx-lightgreen;\n$success: $palx-darkishgreen;\n$warn: #dc8f20;\n$lightwarn: lighten($warn, 25);\n\n$lightdangerAlpha: rgba($lightdanger, 0.5);\n$dangerAlpha: rgba($danger, 0.5);\n$lightsuccessAlpha: rgba($lightsuccess, 0.5);\n$successAlpha: rgba($success, 0.5);\n$lightwarnAlpha: rgba($lightwarn, 0.5);\n$warnAlpha: rgba($warn, 0.5);\n\n$click-danger: $danger;\n$click-success: $success;\n$click-lightsuccess: $lightsuccess;\n\n$click-subjects: (\n  his,\n  geo,\n  ere,\n  fil,\n  soc,\n  efi,\n  cie,\n  bio,\n  qui,\n  fis,\n  mat,\n  ing,\n  esp,\n  por,\n  lit,\n  art,\n  tra,\n  inf,\n  lib\n);\n\n:root {\n  --his: #{$palx-red};\n  --geo: #{$palx-orange};\n  --ere: #{$palx-yellow};\n  --fil: #{$palx-yellow};\n  --soc: #{$palx-yellow};\n  --efi: #{$palx-lime};\n  --cie: #{$palx-green};\n  --bio: #{$palx-green};\n  --inf: #{$palx-green};\n  --qui: #{$palx-teal};\n  --fis: #{$palx-cyan};\n  --mat: #{$palx-blue};\n  --ing: #{$palx-indigo};\n  --esp: #{$palx-indigo};\n  --por: #{$palx-violet};\n  --lit: #{$palx-fuschia};\n  --art: #{$palx-pink};\n  --tra: #{$palx-gray};\n  --lib: #{$palx-gray};\n\n  .nightMode {\n    --his: #{$palx-lightred};\n    --geo: #{$palx-lightorange};\n    --ere: #{$palx-lightyellow};\n    --fil: #{$palx-lightyellow};\n    --soc: #{$palx-lightyellow};\n    --efi: #{$palx-lightlime};\n    --cie: #{$palx-lightgreen};\n    --bio: #{$palx-lightgreen};\n    --inf: #{$palx-lightgreen};\n    --qui: #{$palx-lightteal};\n    --fis: #{$palx-lightcyan};\n    --mat: #{$palx-lightblue};\n    --ing: #{$palx-lightindigo};\n    --esp: #{$palx-lightindigo};\n    --por: #{$palx-lightviolet};\n    --lit: #{$palx-lightfuschia};\n    --art: #{$palx-lightpink};\n    --tra: #{$palx-lightgray};\n    --lib: #{$palx-lightgray};\n  }\n}\n\n$subjects-colors: (\n  his: (\n    dark: $palx-darkred,\n    regular: $palx-red,\n    light: $palx-lightred,\n  ),\n  geo: (\n    dark: $palx-darkorange,\n    regular: $palx-orange,\n    light: $palx-lightorange,\n  ),\n  ere: (\n    dark: $palx-darkyellow,\n    regular: $palx-yellow,\n    light: $palx-lightyellow,\n  ),\n  fil: (\n    dark: $palx-darkyellow,\n    regular: $palx-yellow,\n    light: $palx-lightyellow,\n  ),\n  soc: (\n    dark: $palx-darkyellow,\n    regular: $palx-yellow,\n    light: $palx-lightyellow,\n  ),\n  efi: (\n    dark: $palx-darklime,\n    regular: $palx-lime,\n    light: $palx-lightlime,\n  ),\n  cie: (\n    dark: $palx-darkgreen,\n    regular: $palx-green,\n    light: $palx-lightgreen,\n  ),\n  bio: (\n    dark: $palx-darkgreen,\n    regular: $palx-green,\n    light: $palx-lightgreen,\n  ),\n  inf: (\n    dark: $palx-darkgreen,\n    regular: $palx-green,\n    light: $palx-lightgreen,\n  ),\n  qui: (\n    dark: $palx-darkteal,\n    regular: $palx-teal,\n    light: $palx-lightteal,\n  ),\n  fis: (\n    dark: $palx-darkcyan,\n    regular: $palx-cyan,\n    light: $palx-lightcyan,\n  ),\n  mat: (\n    dark: $palx-darkblue,\n    regular: $palx-blue,\n    light: $palx-lightblue,\n  ),\n  ing: (\n    dark: $palx-darkindigo,\n    regular: $palx-indigo,\n    light: $palx-lightindigo,\n  ),\n  esp: (\n    dark: $palx-darkindigo,\n    regular: $palx-indigo,\n    light: $palx-lightindigo,\n  ),\n  por: (\n    dark: $palx-darkviolet,\n    regular: $palx-violet,\n    light: $palx-lightviolet,\n  ),\n  lit: (\n    dark: $palx-darkfuschia,\n    regular: $palx-fuschia,\n    light: $palx-lightfuschia,\n  ),\n  art: (\n    dark: $palx-darkpink,\n    regular: $palx-pink,\n    light: $palx-lightpink,\n  ),\n  lib: (\n    dark: $palx-darkblue,\n    // Azul escuro para profundidade e contraste\n    regular: $palx-blue,\n    // Azul médio para equilíbrio\n    light: $palx-lightblue,\n    // Azul claro para suavidade e clareza\n  ),\n  tra: (\n    dark: $palx-darkgray,\n    regular: $palx-gray,\n    light: $palx-lightgray,\n  ),\n);\n\n$click-status: (\n  error: $danger,\n  success: $success,\n  warning: $warn,\n);\n\n:root {\n  --foreground-color-1: #{$palx-darkgray};\n  --foreground-color-1-alpha: #{rgba($palx-darkgray, 0.25)};\n  --foreground-color-1-light: #{$palx-lightgray};\n  --foreground-color-2: #{$click-blue};\n  --foreground-color-2-alpha: #{rgba($click-blue, 0.5)};\n  --foreground-color-3: #{$white};\n\n  --background-color-1: #{$white};\n  --background-color-1-alpha: #{rgba($white, 0.5)};\n  --background-color-2: #{$click-blue};\n  --background-color-2-alpha: #{rgba($click-blue, 0.5)};\n  --background-color-3: #{$click-darkblue};\n  --background-color-3-alpha: #{rgba($click-darkblue, 0.5)};\n  --background-color-4: #{$click-gray-10};\n\n  --grassColor: #9acc00;\n  --mudColor: saddlebrown;\n  --mudColor-alpha: #{rgba(saddlebrown, 0.5)};\n\n  --flowerPetal: #f00000;\n  --flowerCore: #efc10e;\n\n  --sparkColor: #f68b1e;\n\n  --bushColor: #1d7208;\n\n  --balloonBackground: #{$white};\n\n  --wood: #8b4513;\n  --woodHighlight: #4e2103;\n  --riverWater: #{$click-blue};\n  --stone: #cccccc;\n\n  --warn: #{$warn};\n  .nightMode {\n    --foreground-color-1: #{$white};\n    --foreground-color-1-alpha: #{rgba($white, 0.25)};\n    --foreground-color-1-light: #{$palx-darkgray};\n    --foreground-color-2: #{$lightblue};\n    --foreground-color-2-alpha: #{rgba($lightblue, 0.5)};\n\n    --background-color-1: #{$black};\n    --background-color-1-alpha: #{rgba($black, 0.5)};\n    --background-color-2: #{$palx-darkgray};\n    --background-color-3: #{$white};\n    --background-color-3-alpha: #{rgba($white, 0.5)};\n    --background-color-4: #{$click-darkgray};\n\n    --grassColor: #05211a;\n    --mudColor: #010000;\n    --mudColor-alpha: #{rgba(#010000, 0.5)};\n\n    --flowerPetal: #363357;\n    --flowerCore: #ffffe0;\n\n    --sparkColor: #ff0;\n\n    --bushColor: #0b3a00;\n\n    --balloonBackground: #081824;\n\n    --wood: #1d0c00;\n    --woodHighlight: #140800;\n    --riverWater: #{$click-darkblue};\n    --stone: #3a3a3a;\n  }\n  @each $subject, $colors in $subjects-colors {\n    .#{$subject} {\n      --foreground-color-2: #{map-get($colors, \"regular\")};\n      --background-color-2: #{map-get($colors, \"regular\")};\n      --background-color-3: #{map-get($colors, \"dark\")};\n      --background-color-3-alpha: #{rgba(map-get($colors, \"dark\"), 0.5)};\n      --subject: #{map-get($colors, \"regular\")};\n      --darksubject: #{map-get($colors, \"dark\")};\n      --lightsubject: #{map-get($colors, \"light\")};\n      --subjectAlpha: #{rgba(map-get($colors, \"regular\"), 0.5)};\n      --darksubjectAlpha: #{rgba(map-get($colors, \"dark\"), 0.5)};\n      --lightsubjectAlpha: #{rgba(map-get($colors, \"light\"), 0.5)};\n      &.nightMode {\n        --foreground-color-2: #{map-get($colors, \"light\")};\n        --background-color-2: #{map-get($colors, \"dark\")};\n      }\n    }\n  }\n}\n","@import \"core/_colors.scss\";\n\n@media print {\n  @page {\n    size: A4 portrait;\n    margin: 0;\n  }\n  * {\n    box-sizing: border-box;\n    transition: none !important;\n  }\n  body > *:not(#print-root) {\n    display: none;\n  }\n  body,\n  #print-root {\n    color-adjust: exact;\n  }\n  #print-root {\n    --blue: $darkblue;\n    --darkblue: $darkgray;\n    --lightgray: white;\n    --gray: black;\n    --darkgray: black;\n    --white: white;\n    --black: black;\n  }\n\n  .page {\n    margin: 0;\n    min-height: 100vh !important;;\n    width: 100vw !important;\n    font-family: Arial;\n    display: flex;\n    flex-wrap: wrap;\n    padding: 4mm;\n    align-items: flex-start;\n    justify-content: flex-start;\n    align-content: flex-start;\n    page-break-after: always !important;\n    overflow: hidden;\n\n    :first-of-type .tag {\n      transform: translateY(0.5mm);\n    }\n    :last-child {\n      height: auto;\n    }\n  }\n\n  .tag-wrapper {\n    position: relative;\n    width: 50%;\n    height: 38.3mm;\n    min-height: 38.3mm;\n    max-height: 38.3mm;\n    page-break-inside: avoid;\n\n    .tag {\n      position: absolute;\n      top: 3mm;\n      left: 3mm;\n      right: 3mm;\n      bottom: 3mm;\n      border: 0.4mm solid #ccc;\n      display: grid;\n      padding: 2mm;\n      border-radius: 2mm;\n      gap: 1mm;\n      grid-template:\n        \"levelGrade site\" 1fr\n        \"name name\" 2fr\n        \"credentials credentials\" 3fr\n        / 1fr 1fr;\n      overflow: hidden;\n\n      .name {\n        grid-area: name;\n        font-weight: var(--bold);\n        border-bottom: 0.4mm solid #ccc;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        font-size: 11pt;\n      }\n\n      .levelGrade {\n        grid-area: levelGrade;\n        font-size: 8pt;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n      }\n\n      .site {\n        grid-area: site;\n        text-align: right;\n        font-size: 8pt;\n      }\n\n      .credentials {\n        grid-area: credentials;\n        display: flex;\n        flex-direction: column;\n\n        h4 {\n          margin: 0;\n          padding: 0;\n          font-size: 9.5pt;\n        }\n\n        p {\n          margin: 0;\n          padding: 0;\n          font-size: 10pt;\n        }\n\n        .password {\n          margin-top: 2px;\n          flex-shrink: 1;\n         \n        }\n      }\n\n      .logo {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        filter: grayscale(1) opacity(0.15);\n        display: flex;\n        align-items: flex-end;\n        justify-content: flex-end;\n        padding: 2mm;\n\n        img {\n          height: 50%;\n        }\n      }\n    }\n  }\n}\n\n@media not print {\n  #print-root {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
